let currentSlide = 0;
const slides = document.querySelectorAll('.slide');
const totalSlides = slides.length;
const dotsContainer = document.getElementById('sliderDots');
const prevYearSpan = document.getElementById('prevYear');
const nextYearSpan = document.getElementById('nextYear');
let isAnimating = false;

for (let i = 0; i < totalSlides; i++) {
  const dot = document.createElement('button');
  dot.classList.add('dot');
  dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
  if (i === 0) dot.classList.add('active');
  dot.onclick = () => goToSlide(i);
  dotsContainer.appendChild(dot);
}

function updateNavigationYears() {
  const prevIndex = (currentSlide - 1 + totalSlides) % totalSlides;
  const nextIndex = (currentSlide + 1) % totalSlides;
  
  const prevYear = slides[prevIndex].querySelector('.year-display').textContent;
  const nextYear = slides[nextIndex].querySelector('.year-display').textContent;
  
  prevYearSpan.textContent = prevYear;
  nextYearSpan.textContent = nextYear;
}

function updateSlider(targetSlide) {
  if (isAnimating) return;
  isAnimating = true;

  slides[currentSlide].classList.remove('active');
  slides[currentSlide].classList.add('fade-out');

  currentSlide = targetSlide;

  setTimeout(() => {
    slides.forEach(slide => slide.classList.remove('fade-out'));
    slides[currentSlide].classList.add('active');
    
    setTimeout(() => {
      isAnimating = false;
    }, 100);
  }, 100);
  
  document.querySelectorAll('.dot').forEach((dot, index) => {
    dot.classList.toggle('active', index === currentSlide);
  });
  
  updateNavigationYears();
}

function moveSlide(direction) {
  let targetSlide = currentSlide + direction;
  
  if (targetSlide < 0) {
    targetSlide = totalSlides - 1;
  } else if (targetSlide >= totalSlides) {
    targetSlide = 0;
  }
  
  updateSlider(targetSlide);
}

function goToSlide(index) {
  if (index !== currentSlide) {
    updateSlider(index);
  }
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowLeft') moveSlide(-1);
  if (e.key === 'ArrowRight') moveSlide(1);
});

document.addEventListener('DOMContentLoaded', () => {
  updateNavigationYears();
});